import React from 'react'

import IconSvgs from '../condition/IconSvgs'
import ConditionPage from '../condition/ConditionPage'

export default ({ prospectDocuments, bodyStyle, interiorSeatRows, ...props }) => {
  const conditionQuestions = prospectDocuments.documents && prospectDocuments.documents.find(document => document.id.split('/')[0] === 'qc').items.filter(item => item.section === 'Aftermarket')

  const title = 'Vehicle Modifications'
  const svgIcons = ['Stereo', 'Wheels & Tires', 'Suspension', 'Remote Start', 'Exhaust', 'Spoiler', 'Performance Modifications', 'Window Tint', 'Other']

  return (
    <ConditionPage
      {...{ title, conditionQuestions, svgIcons, ...props }}
      pageName={'aftermarket'}
      noDamage={'No vehicle modifications? Select Next.'}
      subheader={'Modifications are anything that was added after the original purchase, but it can also be upgrades or changes from the dealer.'}>
      <IconSvgs {...{ titleOverride: 'Has your vehicle had any modifications?', conditionQuestions, svgIcons, ...props }} />
    </ConditionPage>
  )
}
